export default "__VITE_ASSET__$M7WU2FE__"